import React, { useEffect, useRef, useState } from "react";
import s from "./styles.module.css";

const SearchSelect = React.forwardRef(
    ({ label, options, placeholder, selected, setSelected, register, apiKey, error }, ref) => {
        const [isOpen, setIsOpen] = useState(false);
        const [searchTerm, setSearchTerm] = useState("");
        const selectRef = useRef(null);

        // Фильтруем районы внутри регионов (если apiKey === "district_id")
        const filteredDistricts =
            apiKey === "district_id"
                ? options
                    .map((region) => ({
                        ...region,
                        districts: region.districts.filter((district) =>
                            district.label.toLowerCase().includes(searchTerm.toLowerCase())
                        ),
                    }))
                    .filter((region) => region.districts.length > 0) // Убираем регионы без совпадений
                : options;

        // Фильтруем options только для agents
        const filteredOptions =
            apiKey === "agents"
                ? options.filter((option) =>
                    option.label.toLowerCase().includes(searchTerm.toLowerCase())
                )
                : options;

        const handleSelect = (option) => {
            if (apiKey === "agents") {
                if (Array.isArray(selected)) {
                    if (selected.includes(option.value)) {
                        setSelected(selected.filter((id) => id !== option.value));
                    } else {
                        setSelected([...selected, option.value]);
                    }
                } else {
                    setSelected([option.value]);
                }
            } else {
                setSelected(option.value);
            }
            setIsOpen(false);
            setSearchTerm(""); // Очищаем поиск после выбора
        };

        const getSelectedLabel = () => {
            if (apiKey === "agents" && Array.isArray(selected) && selected.length > 0) {
                return options
                    .filter((option) => selected.includes(option.value))
                    .map((option) => option.label)
                    .join(", ");
            }

            if (apiKey === "district_id" && selected) {
                const selectedOption = options
                    .flatMap((region) => region.districts)
                    .find((option) => option.value === selected);
                return selectedOption ? selectedOption.label : placeholder;
            }

            if (selected) {
                const selectedOption = options.find((option) => option.value === selected);
                return selectedOption ? selectedOption.value : placeholder;
            }

            return placeholder;
        };

        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm("");
            }
        };

        useEffect(() => {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, []);

        return (
            <div ref={selectRef} className={`${s.customSelect} ${error ? s.error : ""}`}>
                <h3 className={s.label}>{label}</h3>
                <div className={s.selectHeader} onClick={() => setIsOpen(!isOpen)}>
                    <span>{getSelectedLabel()}</span>
                    <div className={`${s.arrow} ${isOpen ? `${s.open}` : ""}`}>&#9662;</div>
                </div>

                {isOpen && (
                    <div className={`${s.selectOptions} custom-scrollbar`}>
                        {/* Поле поиска только для agents и district_id */}
                        {(apiKey === "agents" || apiKey === "district_id") && (
                            <input
                                type="text"
                                placeholder="Поиск..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className={s.searchInput}
                            />
                        )}

                        {/* Для district_id (регионы и районы) */}
                        {apiKey === "district_id" &&
                            filteredDistricts.map((region) => (
                                <div key={region.title}>
                                    <h4 className={s.regionTitle}>{region.title}</h4>
                                    {region.districts.map((option) => (
                                        <label key={option.value} className={s.selectOption}>
                                            <input
                                                type="radio"
                                                name="district_id"
                                                checked={selected === option.value}
                                                onChange={() => handleSelect(option)}
                                                ref={register}
                                            />
                                            {option.label}
                                        </label>
                                    ))}
                                </div>
                            ))}

                        {/* Для agents */}
                        {apiKey === "agents" &&
                            filteredOptions.map((option) => (
                                <label key={option.value} className={s.selectOption}>
                                    <input
                                        type="checkbox"
                                        checked={Array.isArray(selected) && selected.includes(option.value)}
                                        onChange={() => handleSelect(option)}
                                        ref={register}
                                    />
                                    {option.label}
                                </label>
                            ))}

                        {/* Для остальных apiKey (без поиска) */}
                        {apiKey !== "agents" && apiKey !== "district_id" &&
                            options.map((option) => (
                                <label key={option.value} className={s.selectOption}>
                                    <input
                                        type="radio"
                                        checked={selected === option.value}
                                        onChange={() => handleSelect(option)}
                                        ref={register}
                                    />
                                    {option.value}
                                </label>
                            ))}

                        {/* Сообщение "Ничего не найдено", если список пуст */}
                        {((apiKey === "agents" && filteredOptions.length === 0) ||
                            (apiKey === "district_id" && filteredDistricts.length === 0)) && (
                            <p className={s.noResults}>Ничего не найдено</p>
                        )}
                    </div>
                )}
            </div>
        );
    }
);

export default SearchSelect;
